export default "__VITE_ASSET__BrIKL5AA__"